"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLayoutDataFromJSON = AdminLayoutDataFromJSON;
exports.AdminLayoutDataFromJSONTyped = AdminLayoutDataFromJSONTyped;
exports.AdminLayoutDataToJSON = AdminLayoutDataToJSON;
exports.AdminLayoutDataToJSONTyped = AdminLayoutDataToJSONTyped;
const runtime_1 = require("../runtime");
function AdminLayoutDataFromJSON(json) {
    return AdminLayoutDataFromJSONTyped(json, false);
}
function AdminLayoutDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'folderId': !(0, runtime_1.exists)(json, 'folderId') ? undefined : json['folderId'],
        'label': json['label'],
        'description': json['description'],
        'html': json['html'],
        'layoutFile': !(0, runtime_1.exists)(json, 'layoutFile') ? undefined : json['layoutFile'],
    };
}
function AdminLayoutDataToJSON(value) {
    return AdminLayoutDataToJSONTyped(value, false);
}
function AdminLayoutDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'folderId': value.folderId,
        'label': value.label,
        'description': value.description,
        'html': value.html,
        'layoutFile': value.layoutFile,
    };
}
